<template>
<div v-if="team && roster && hasStadium !== null">
      <div class="row columns">
          <div class="large-12 inner-title">
              Les Stades :
          </div>
          <div class="large-12 inner-subtitle" v-if="hasStadium">
              Vous êtes déjà résident d'un stade, la seule chose qu'il vous reste à faire c'est le vendre.
              <hr>
          </div>
          <template v-else>
              <div class="large-12 inner-subtitle">
                  Vous pouvez économiser pour acheter un stade, par tranche de 70 000 pO, ou en acheter un cash, si vous avez de la caillasse
              </div>
              <div v-if="missingMoneyForStadium < 250" class="large-12 inner-subtitle">
                  vous avez déjà mis de côté {{250 - missingMoneyForStadium}} 000 pO pour acheter votre stade
              </div>
              <table>
                  <thead>
                      <tr class="">
                          <th width="200">Type</th>
                          <th width="5">Prix</th>
                          <th width="5">action</th>
                      </tr>
                  </thead>
                  <tbody class="roster" v-if="roster">
                      <tr>
                          <td class="action">
                            Mettre de l'argent de côté pour le stade
                          </td>
                          <td>70 000</td>
                          <td colspan="2" v-if="saveMoney === false" class="action">
                              <button :disabled="saveMoneyCost > currentTreasury"
                                      :class="{deactivated:saveMoneyCost > currentTreasury, action:true}"
                                      v-on:click="saveMoney = true">Ajouter au panier</button>
                          </td>
                          <td colspan="2" v-if="saveMoney === true" class="action">
                            <button class="action alert" v-on:click="saveMoney = false">Retirer du panier</button>
                          </td>
                      </tr>
                      <tr>
                          <td class="action">
                            Acheter un stade cash
                          </td>
                          <td>{{missingMoneyForStadium}} 000</td>
                          <td colspan="2" v-if="stadiumPurchase === false" class="action">
                              <button :disabled="missingMoneyForStadium > currentTreasury"
                                :class="{deactivated:missingMoneyForStadium > currentTreasury, action:true}"
                                v-on:click="stadiumPurchase = true">Ajouter au panier</button>
                          </td>
                          <td colspan="2" v-if="stadiumPurchase == true" class="action">
                            <button class="action alert" v-on:click="stadiumPurchase = false">Retirer du panier</button>
                          </td>
                      </tr>

                      <tr>
                          <td class="sous-total right">Budget Stade</td>
                          <td class="sous-total">{{stadiumBudget}} 000</td>
                          <td colspan="2"></td>
                      </tr>
                  </tbody>
              </table>
          </template>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import spinner from '../../common/spinner.vue'
import messageModal from '../../common/message-modal.vue'
import playerPurchaseModal from '../../common/player-purchase-modal.vue'

export default {
  name: 'stadiumPurchases',
  components: {
    spinner,
    messageModal,
    playerPurchaseModal
  },
  props: {
    'roster': {},
    'team': {},
    'currentTreasury': 0
  },
  data () {
    return {
      // la liste des joueurs actuellement présents dans l'équipe, et de ceux que l'on achète
      saveMoney: false,
      saveMoneyCost: 70,
      stadiumPurchase: false
    }
  },
  computed: {
    ...mapGetters([
      'missingMoneyForStadium',
      'hasStadium'
    ]),
    stadiumBudget: function () {
      let budget = 0
      if (this.saveMoney) {
        budget += 70
      }
      if (this.stadiumPurchase) {
        budget += this.missingMoneyForStadium
      }
      return budget
    }
  },
  watch: {
    saveMoney: function (val) {
      this.$emit('updateStadiumCost')
    },
    stadiumPurchase: function (val) {
      this.$emit('updateStadiumCost')
    }
  },
  mounted () {
    this.$store.dispatch('getExpensesForTeam', this.team.id)
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.7rem;
    font-weight: 300;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}
.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
}

.inner-subtitle{
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 0.3rem
}
</style>



// WEBPACK FOOTER //
// stadium-purchase.vue?b31a8644